export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/breadcrumb-arrow.4551cf0f-8a9f90.svg";